import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Always succeeds from the API's point of view (it never reveals whether
      // the email exists) -- the UI shows the same generic confirmation either way.
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Qualcosa è andato storto. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex justify-center mb-8" data-testid="forgot-brand-link">
          <img src="/brand/logo-black.png" alt="ourweddly" className="h-12 w-auto" />
        </Link>
        <p className="eyebrow mb-3 text-center">Recupero password</p>
        <h1 className="font-wed text-4xl mb-8 text-center">Password dimenticata?</h1>
        <div className="bg-white border rounded-3xl p-8 space-y-5" style={{ borderColor: "#e3ddd2" }}>
          {sent ? (
            <p className="text-sm text-neutral-600 text-center" data-testid="forgot-password-sent">
              Se quell'indirizzo è registrato, ti abbiamo appena mandato un'email con il link per scegliere una nuova password.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <p className="text-sm text-neutral-500">Inserisci l'email con cui ti sei registrato: ti mandiamo un link per reimpostare la password.</p>
              <div>
                <label className="label-wed">Email</label>
                <input className="input-wed" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.it" required data-testid="forgot-email-input" />
              </div>
              <button type="submit" className="btn-wed w-full" disabled={loading} data-testid="forgot-submit-button">
                {loading ? "Invio…" : "Invia il link"}
              </button>
            </form>
          )}
        </div>
        <p className="text-center text-sm text-neutral-500 mt-6">
          <Link to="/login" style={{ color: "var(--wed-primary)" }} data-testid="forgot-back-to-login">Torna al login</Link>
        </p>
      </div>
    </div>
  );
}
